import React from 'react';
import * as Icon from 'react-feather';

const IconLink = ({href, text, icon, linkClass, size}) => {
    const IconComponent = Icon[icon];
    return (
        <a className={`${linkClass ? linkClass : 'sl-inline-flex sl-btn sl-btn-md sl-btn-link-gray sl-text-sm sl-no-underline'}`}
           href={href}
           target="_self" rel="noreferrer">
            <IconComponent className={'sl-mr-2-point-5'} size={size ?? 24}/>
            {text}
        </a>
    );
};

export default IconLink;
